var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm._f("formatDecimal")(_vm.value,_vm.precision, true))+" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.uomDisplayUnits)}})])}
var staticRenderFns = []

export { render, staticRenderFns }